import { render } from "./SelectMulti.vue?vue&type=template&id=2dcce5a4&scoped=true"
import script from "./SelectMulti.vue?vue&type=script&lang=js"
export * from "./SelectMulti.vue?vue&type=script&lang=js"

import "./SelectMulti.vue?vue&type=style&index=0&id=2dcce5a4&lang=less&scoped=true"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcce5a4"]])

export default __exports__